<template>
  
    <div class="admin-layout">
    <!-- Sidebar affichée -->
    <SidebarAdmin />
    
    <!-- Contenu principal -->
  <div class="dashboard-admin">
    <h2>Tableau de bord général</h2>
    <!-- Statistiques -->
    <div class="stats-grid">
      <div class="card stat-card">
        <h3>👤 Clients</h3>
        <p>{{ clientsCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>📦 Commandes</h3>
        <p>{{ ordersCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>🚚 En attente</h3>
        <p>{{ pendingCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>💰 Total ventes</h3>
        <p>{{ totalSales.toFixed(2) }} MAD</p>
      </div>
    </div>

    <!-- Graphiques -->
    <AdminChart />
    <AdminBarChart />

    <!-- Activités récentes -->
    <div class="recent-section">
      <h3>🕓 Activités récentes</h3>
      <ul>
        <li v-for="(order, i) in recentOrders" :key="i">
          <span>{{ formatDate(order.createdAt) }}</span> — 
          {{ order.user?.prenom }} {{ order.user?.nom }} a passé une commande ({{ order.status }})
        </li>
      </ul>
    </div>
    </div>
  </div>
  
</template>

<script>
import axios from "axios";
//import AdminChart from "@/components/admin/AdminChart.vue";
//import AdminBarChart from "@/components/admin/AdminBarChart.vue";
import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";
export default {
  name: "DashboardAdmin",
  components: { SidebarAdmin },
  //components: { AdminChart, AdminBarChart },
  data() {
    return {
      clientsCount: 0,
      ordersCount: 0,
      pendingCount: 0,
      totalSales: 0,
      recentOrders: [],
    };
  },
  async mounted() {
    try {
      const [clientsRes, ordersRes] = await Promise.all([
        axios.get("http://localhost:2028/api/users"),
        axios.get("http://localhost:2028/api/orders"),
      ]);

      this.clientsCount = clientsRes.data.length;
      this.ordersCount = ordersRes.data.length;
      this.pendingCount = ordersRes.data.filter(o => o.status === "En attente").length;
      this.totalSales = ordersRes.data.reduce((sum, o) => sum + (o.total || 0), 0);
      this.recentOrders = ordersRes.data.slice(-5).reverse();
    } catch (err) {
      console.error("Erreur chargement stats admin:", err);
    }
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString("fr-FR");
    }
  }
};
</script>

<style scoped>
/* --- LAYOUT --- */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: "Poppins", sans-serif;

}

.dashboard-admin {
  flex: 1;
  padding: 40px;
  color: #222;
  overflow-y: auto;
}

/* --- HEADER --- */
.dashboard-header {
  margin-bottom: 30px;
}
.dashboard-header h2 {
  color: #05305b;
  font-size: 26px;
  margin-bottom: 5px;
}
.dashboard-header .subtitle {
  font-size: 15px;
  color: #777;
}

/* --- STATISTIQUES --- */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.stat-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.stat-card .icon {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
}
.bg-blue { background-color: #00998B; }
.bg-green { background-color: #28a745; }
.bg-orange { background-color: #ff9800; }
.bg-purple { background-color: #6f42c1; }

.stat-card .info h3 {
  font-size: 15px;
  color: #555;
}
.stat-card .info p {
  font-size: 24px;
  color: #05305b;
  font-weight: 700;
  margin-top: 5px;
}

/* --- ACTIVITÉS RÉCENTES --- */
.recent-section {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}
.recent-section h3 {
  margin-bottom: 15px;
  color: #05305b;
  font-size: 18px;
  font-weight: 600;
}
.recent-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.recent-section li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  color: #444;
}
.recent-section li:last-child {
  border-bottom: none;
}
.date {
  color: #00998B;
  font-weight: 500;
}
.status {
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  margin-left: 4px;
  color: white;
  font-size: 13px;
}
.status.en attente { background: #ff9800; }
.status.confirmée { background: #00998B; }
.status.expediee { background: #3f51b5; }
.status.livree { background: #4caf50; }

/* --- DARK MODE --- */
@media (prefers-color-scheme: dark) {
  .admin-layout { background: #0f1720; }
  .dashboard-admin { color: #e6edf1; }
  .stat-card, .recent-section {
    background: #1c2733;
    box-shadow: 0 4px 10px rgba(0,0,0,0.6);
  }
  .stat-card .info p { color: #00c8b3; }
  .recent-section h3 { color: #00c8b3; }
  .recent-section li { border-bottom: 1px solid #333; }
}

/* --- RESPONSIVE --- */
@media (max-width: 1024px) {
  .dashboard-admin {
    padding: 20px;
  }
}
@media (max-width: 600px) {
  .stat-card {
    flex-direction: column;
    text-align: center;
  }
  .stat-card .icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
}
</style>
